import { SECTION_IDS } from "../constants/sections";
import { STORY_STRINGS } from "../constants/strings";

function StorySection() {
  return (
    <section id={SECTION_IDS.story} className="section story-section">
      <div className="section-inner split-layout">
        <div>
          <p className="eyebrow">{STORY_STRINGS.eyebrow}</p>
          <h2>{STORY_STRINGS.heading}</h2>
          {STORY_STRINGS.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>

        <div
          className="highlight-panel story-panel"
          aria-label={STORY_STRINGS.highlightsAriaLabel}
        >
          {STORY_STRINGS.highlights.map((item) => (
            <div className="highlight-item" key={item}>
              <span aria-hidden="true">★</span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StorySection;
